module.exports = __webpack_public_path__ + "img/merci-partage-mobile.039177a6.jpg";